/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const SetPrimaryEmailBody = zod.object({
  email: zod.email().describe('The VERIFIED secondary address to promote to primary'),
});

export type SetPrimaryEmailBody = zod.input<typeof SetPrimaryEmailBody>;
export type SetPrimaryEmailBodyOutput = zod.output<typeof SetPrimaryEmailBody>;
